import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { NotificationService } from "../api";

export const actionGetListNotification = createAsyncThunk(
  "order/list-notification",
  async (_, { rejectWithValue }) => {
    try {
      const res = await NotificationService.doGetListNotification();
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

export const actionSeenHistoryDoctor = createAsyncThunk(
  "order/seen-history-doctor",
  async (_, { rejectWithValue }) => {
    try {
      const res = await NotificationService.doSeenHistoryDoctor();
      if (!res.data.status) {
        // toast.success(res.data.message);
        return res.data;
      } else {
        toast.error(res.data.message);
        return rejectWithValue(res.data);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      return rejectWithValue(message);
    }
  }
);

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    listNotification: {
      loading: false,
      data: null,
      error: "",
    },
    seenHistoryDoctor: {
      loading: false,
      data: null,
      error: "",
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // listNotification
      .addCase(actionGetListNotification.pending, (state) => {
        state.listNotification.loading = true;
      })
      .addCase(actionGetListNotification.fulfilled, (state, action) => {
        state.listNotification.loading = false;
        state.listNotification.data = action.payload;
      })
      .addCase(actionGetListNotification.rejected, (state, action) => {
        state.listNotification.loading = false;
        state.listNotification.data = action.payload;
        state.listNotification.error =
          action.error.message || "Something went wrong";
      })

      // seenHistoryDoctor
      .addCase(actionSeenHistoryDoctor.pending, (state) => {
        state.seenHistoryDoctor.loading = true;
      })
      .addCase(actionSeenHistoryDoctor.fulfilled, (state, action) => {
        state.seenHistoryDoctor.loading = false;
        state.seenHistoryDoctor.data = action.payload;
      })
      .addCase(actionSeenHistoryDoctor.rejected, (state, action) => {
        state.seenHistoryDoctor.loading = false;
        state.seenHistoryDoctor.data = action.payload;
        state.seenHistoryDoctor.error =
          action.error.message || "Something went wrong";
      });
  },
});

export default notificationSlice.reducer;
export const { actions, reducer } = notificationSlice;
